export default "__VITE_ASSET__29789505__"